var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.homeBg },
    [
      _c(
        "video",
        {
          class: _vm.$style.backgroundVideo,
          attrs: {
            autoplay: "",
            preload: "auto",
            muted: "",
            poster: require("@/assets/img/main-bg.jpg"),
            loop: "",
            playsinline: ""
          },
          domProps: { muted: true }
        },
        [
          _c("source", {
            attrs: { src: _vm.backgroundVideo, type: "video/mp4" }
          })
        ]
      ),
      _vm._v(" "),
      !_vm.$route.meta.hideHeader ? _c("DesktopHeader") : _vm._e(),
      _vm._v(" "),
      _vm.$route.meta.registrationHeader
        ? _c("DesktopRegistrationHeader")
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading && !_vm.isGuest
        ? _c("LoadingSpinner")
        : _c(
            "v-content",
            [
              _c("Cart", {
                attrs: {
                  display: _vm.showCart,
                  "current-page": _vm.$route.name
                },
                on: {
                  closeCart: function($event) {
                    return _vm.setCartDisplay(false)
                  },
                  checkout: _vm.checkout
                }
              }),
              _vm._v(" "),
              _c("router-view", { key: _vm.$route.fullPath }),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.authModalSignIn,
                    width: 720,
                    title: "Join / Sign In",
                    type: "BigModal",
                    name: "signIn"
                  },
                  on: { toggleModal: _vm.setModalSignInVisibility }
                },
                [
                  _c("SignIn", {
                    on: {
                      phoneChecked: _vm.phoneCheckedSignIn,
                      close: function($event) {
                        return _vm.setModalSignInVisibility(false)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.authModalClaimAccount,
                    width: 720,
                    title: "Claim Account",
                    type: "BigModal"
                  },
                  on: { toggleModal: _vm.setModalClaimAccountVisibility }
                },
                [
                  _c("ClaimAccount", {
                    on: {
                      phoneChecked: _vm.phoneCheckedClaimAccount,
                      close: function($event) {
                        return _vm.setModalClaimAccountVisibility(false)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.authModalLogin,
                    width: 720,
                    title: "Welcome Back",
                    type: "BigModal"
                  },
                  on: { toggleModal: _vm.setModalLoginVisibility }
                },
                [
                  _c("Login", {
                    on: {
                      close: function($event) {
                        return _vm.setModalLoginVisibility(false)
                      },
                      forgotPassword: _vm.setForgotPassword,
                      authorized: function($event) {
                        return _vm.setModalLoginVisibility(false)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.authForgotPassword,
                    width: 720,
                    title: "Forgot Password",
                    type: "BigModal",
                    name: "forgotPassword"
                  },
                  on: { toggleModal: _vm.setForgotPasswordVisibility }
                },
                [
                  _c("ForgotPassword", {
                    on: {
                      linkSent: _vm.setLinkSent,
                      close: function($event) {
                        return _vm.setModal("forgotPassword", false)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.authModal("resetPassword"),
                    width: 720,
                    title: "Password Reset",
                    type: "BigModal",
                    name: "resetPassword"
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.setResetPasswordVisibility(arguments[1])
                    }
                  }
                },
                [
                  _c("PasswordReset", {
                    on: {
                      close: function($event) {
                        return _vm.setResetPasswordVisibility(false)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.authModal("linkSent"),
                    width: 280,
                    "always-modal": true,
                    title: "Password Reset",
                    type: "SmallModal",
                    name: "linkSent"
                  },
                  on: { toggleModal: _vm.setModal }
                },
                [
                  _c("LinkSent", {
                    on: {
                      close: function($event) {
                        return _vm.setModal("linkSent", false)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.modalInfo("cartItemRemove") !== null,
                    "always-modal": true,
                    width: "480",
                    type: "AppendModal",
                    title: "Remove Item",
                    name: "cartItemRemove"
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.modalUpdate({ name: "cartItemRemove" })
                    }
                  }
                },
                [
                  _c("ConfirmModalContent", {
                    attrs: {
                      message:
                        "Are you sure you want to remove this item from your order?",
                      "confirm-text": "YES, REMOVE",
                      "cancel-text": "NO"
                    },
                    on: {
                      confirm: _vm.handleRemoveItem,
                      cancel: function($event) {
                        return _vm.modalUpdate({ name: "cartItemRemove" })
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.modalInfo("cartItemEdit") !== null,
                    "always-modal": true,
                    width: "480",
                    type: "AppendModal",
                    title: "Abandon Boss Creation?",
                    name: "cartItemEdit"
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.modalUpdate({ name: "cartItemEdit" })
                    }
                  }
                },
                [
                  _c("ConfirmModalContent", {
                    attrs: {
                      message:
                        "Are you sure you want to abandon this creation?",
                      "confirm-text": "YES, ABANDON",
                      "cancel-text": "NO"
                    },
                    on: {
                      confirm: _vm.handleConfirmEditItem,
                      cancel: function($event) {
                        return _vm.modalUpdate({ name: "cartItemEdit" })
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.modalInfo("cartItemAdd"),
                    "always-modal": true,
                    width: "480",
                    type: "AppendModal",
                    title: "Abandon Boss Creation?",
                    name: "cartItemAdd"
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.modalUpdate({ name: "cartItemAdd" })
                    }
                  }
                },
                [
                  _c("ConfirmModalContent", {
                    attrs: {
                      message:
                        "Are you sure you want to abandon this creation?",
                      "confirm-text": "YES, ABANDON",
                      "cancel-text": "NO"
                    },
                    on: {
                      confirm: _vm.addNewItem,
                      cancel: function($event) {
                        return _vm.modalUpdate({ name: "cartItemAdd" })
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.modalInfo("cartOrderCancel"),
                    "always-modal": true,
                    width: "480",
                    type: "AppendModal",
                    title: "Cancel Order?",
                    name: "cartOrderCancel"
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.modalUpdate({ name: "cartOrderCancel" })
                    }
                  }
                },
                [
                  _c("ConfirmModalContent", {
                    attrs: {
                      message:
                        "Are you sure you want to cancel your entire order?",
                      "confirm-text": "YES, CANCEL",
                      "cancel-text": "NO"
                    },
                    on: {
                      confirm: _vm.cancelOrder,
                      cancel: function($event) {
                        return _vm.modalUpdate({ name: "cartOrderCancel" })
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.modalInfo("goToMenuOrMain"),
                    "always-modal": true,
                    width: "480",
                    type: "AppendModal",
                    title: "Abandon Boss Creation?",
                    name: "goToMenuOrMain"
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.modalUpdate({ name: "goToMenuOrMain" })
                    }
                  }
                },
                [
                  _c("ConfirmModalContent", {
                    attrs: {
                      message:
                        "Are you sure you want to abandon this creation?",
                      "confirm-text": "YES, ABANDON",
                      "cancel-text": "NO"
                    },
                    on: {
                      confirm: _vm.goToMenuOrMain,
                      cancel: function($event) {
                        return _vm.modalUpdate({ name: "goToMenuOrMain" })
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.modalInfo("checkoutModal"),
                    "always-modal": true,
                    width: "700",
                    type: "BigModal",
                    name: "checkoutModal",
                    title: "Checkout"
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.modalUpdate({ name: "checkoutModal" })
                    }
                  }
                },
                [
                  _c("CheckoutModal", {
                    on: {
                      "create-account": _vm.handleCreateAccount,
                      "guest-checkout": _vm.handleGuestCheckout,
                      "sign-in": _vm.handleSignIn
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.modalInfo("guestCheckoutModal"),
                    "always-modal": true,
                    width: "700",
                    type: "BigModal",
                    name: "guestCheckoutModal",
                    title: "Guest Checkout"
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.modalUpdate({ name: "guestCheckoutModal" })
                    }
                  }
                },
                [
                  _c("GuestCheckoutModal", {
                    on: {
                      continue: _vm.checkout,
                      "create-account": _vm.handleCreateAccount,
                      "sign-in": _vm.handleSignIn
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CommonModal",
                {
                  attrs: {
                    display: _vm.showHelpModal,
                    width: _vm.helpModalWidth,
                    "always-modal": "",
                    type: "SmallModal",
                    "no-padding": ""
                  },
                  on: {
                    toggleModal: function($event) {
                      return _vm.toggleHelpModal()
                    }
                  }
                },
                [_c("HelpModal")],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c("ApiErrors")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/layouts/DesktopLayout.vue?vue&type=template&id=43e4eb37&
// module id = null
// module chunks = 